import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import { SIZE_33 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const totalEngagementConfig = {
    name: 'kpi.linkedin.total_engagement',
    id: 'engagement',
    icon: {
        name: 'engagement-on',
        style: colors.green
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    tooltip: 'kpi.linkedin.tooltip_total_engagement',
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_33,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
